// extracted by mini-css-extract-plugin
module.exports = {"transfer-small":"transfer-small--3QibV","transferSmall":"transfer-small--3QibV"};